import React from 'react'
import { MARKS, BLOCKS, INLINES } from "@contentful/rich-text-types"
import { Link } from 'gatsby'
import get from 'lodash/get'
import LeftAlignedImageBlock from '../src/components/contentful/left-aligned-image'
import RightAlignedImageBlock from '../src/components/contentful/right-aligned-image'
import CallToAction from '../src/components/contentful/call-to-action'
import ColumnsBlock from '../src/components/contentful/columns'
import TableBlock from '../src/components/contentful/table'
import { isExternalUrl } from "../src/helpers.js"
import Image from '../src/components/contentful/image'

export default {
  renderMark: {
    [MARKS.BOLD]: text => <strong>{text}</strong>,
  },
  renderNode: {
    [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
      let element = children
      const entryType = get(node, 'data.target.sys.contentType.sys.id')
      
      switch (entryType) {
        case `leftAlignedImage` : 
          element = <LeftAlignedImageBlock node={node.data.target} />
          break
        case `rightAlignedImage` : 
          element = <RightAlignedImageBlock node={node.data.target} />
          break
        case `callToAction` : 
          element = <CallToAction node={node.data.target} />
          break
        case `columnsBlock` : 
          element = <ColumnsBlock node={node.data.target} />
          break
        case `table` : 
          element = <TableBlock node={node.data.target} />
          break
      }
      
      return (
        <>
          {element}
        </>
      )
    },
    [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
      let element = children
      const entryType = get(node, 'data.target.sys.type')
      switch (entryType) {
        case 'Asset' :
          element = <Image node={ node.data.target } />
          break
      }

      return (
        <>
          {element}
        </>
      )
    },
    [INLINES.HYPERLINK]: ({data, content}) => {
      const { uri } = data
      const label = content[0].value
      if (isExternalUrl(uri)) {
        return (<a href={uri} target="_blank">{label}</a>)
      } else {
        return (<Link to={uri}>{label}</Link>)
      }
    }
  }
}